import { apiClientGeral } from '@/plugins/axios'

export default {
  getrotas() {
    return apiClientGeral().get('/rotas')
  },
  getrota(id) {
    return apiClientGeral().get(`/rotas/${id}`)
  },
  postrota(rota) {
    return apiClientGeral().post('/rotas', rota)
  },
  putrota(rota, id) {
    return apiClientGeral().put(`/rotas/${id}`, rota)
  },
  deleterota(id) {
    return apiClientGeral().delete(`/rotas/${id}`)
  },

  getTags() {
    return apiClientGeral().get('/tags')
  },

  getRotaUse(id) {
    return apiClientGeral().get(`/rotas/use/${id}`)
  },

  getGrupos() {
    return apiClientGeral().get('/grupo-rotas')
  },

  getRotasPerGroups(data) {
    return apiClientGeral().get('/rotas/rotas-per-group', data)
  }
}
